import { ApiClient } from "@/services/apiClient";
import { type OnlyPublicProperties } from "@/types";
import type { Filter } from "@/services/collection";
import { type CollectionMetadata, type CollectionStatistics } from "@/services/collection";
import { z } from "zod";
import { WholeNumber_Schema } from "@/utilities";

export const fetchCollectionStatistics = async (filter: OnlyPublicProperties<Filter.Filter>): Promise<CollectionStatistics> => {
  const url = "api/collection/statistics";
  const params = filter.createApiParams();
  return ApiClient.get<CollectionStatistics>(url, params).then((response) => response.data);
};

export const fetchCollectionMetadata = async (filter: OnlyPublicProperties<Filter.Filter>): Promise<CollectionMetadata> => {
  const url = "api/collection/metadata";
  const params = filter.createApiParams();
  return ApiClient.get<CollectionMetadata>(url, params).then((response) => response.data);
};

const ApiResponse_OldMarketplaceItemCount_Schema = z.object({ count: WholeNumber_Schema });
type ApiResponse_OldMarketplaceItemCount = z.infer<typeof ApiResponse_OldMarketplaceItemCount_Schema>;

export const fetchOldMarketplaceItemCount = async (): Promise<number> => {
  const url = "api/collection/old-marketplace-items/count";
  return ApiClient.get<ApiResponse_OldMarketplaceItemCount>(url).then(({ data }) => ApiResponse_OldMarketplaceItemCount_Schema.parse(data).count);
};
